import { routes } from "@/global/routes";
import {
  faqs,
  howItWorks,
  CheckoutTerms,
  InventoryCard,
  skybarSuiteNames,
  SkybarSuiteContent,
  partyDeckSuiteNames,
  PartyDeckSuiteContent,
  ExecutiveSuiteContent,
  allInclusiveSuiteNames,
  inventoryCardSuiteModal,
  outFieldSuperSuiteNames,
  AllInclusiveSuiteContent,
  executiveSuperSuiteNames,
  homePlateSuperSuiteNames,
  thirdBaseSuperSuiteNames,
  powerAlleyPatioSuiteNames,
  OutFieldSuperSuiteContent,
  triplePlayPartySuiteNames,
  ThirdBaseSuperSuiteContent,
  HomePlateSuperSuiteContent,
  machineRoomPatioSuiteNames,
  PowerAlleyPatioSuiteContent,
  TriplePlayPartySuiteContent,
  MachineRoomPatioSuiteContent,
  centerFieldPavilionSuiteNames,
  AdditionalDetailsDisclaimerTC,
  CenterFieldPavilionSuiteContent,
  FujitecSuperSuiteContent,
  fujitecSuperSuiteNames,
  AnalyticsHeader,
} from "./helpers";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";

import { DefaultRegistrationTerms } from "../../default_terms_and_conditions";

import type { TeamConfig } from "../types";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/MLB-3/CIN-3.png";
const BackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/reds-stadium.jpg";
const SeatMap3dPreview =
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/reds-venue-chat.png";
const BannerImage =
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Banner_25-New%20Flow%20Sales%20Images_1486x148-Header.png";

const TriplePlayPartySuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEU4U1RFMTNTRVQyNChJTlQpRQ==",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/TPPS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/TPPS%202.png",
];

const HomePlateSuperSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUyMDIoSU5UKUU=",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/HP%20SS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/HP%20SS%202.png",
];

const ThirdBaseSuperSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUxMTcoSU5UKUU%3D",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Third%20Base%20SS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Third%20Base%20SS%202.png",
];

const OutFieldSuperSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUyMzgoSU5UKUU%3D",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Outfield%20SS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Outfield%20SS%202.png",
];

const ExecutiveSuperSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUyMzUoSU5UKUU=",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Exec%20SS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Exec%20SS%202.png",
];

const CenterFieldPavilionSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19UcmlIZWFsdGhDZW50ZXJGaWVsZFBhdmlsbGlvbihJTlQpRQ%3D%3D",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/CF%20Pav%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/CF%20Pav%202.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/CF%20Pav%203.png",
];

const MachineRoomPatioSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19NYWNoaW5lUm9vbVBhdGlvKElOVClF",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/MR%20Patio%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/MR%20Patio%202.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/MR%20Patio%203.png",
];

const PartyDeckSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19QYXJ0eURlY2tzQWFuZEIoSU5UKUUtMS01",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Party%20Deck%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Party%20Deck%202.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Party%20Deck%203.png",
];

const PowerAlleyPatioSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19Qb3dlckFsbGV5UGF0aW8oSU5UKUU=",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/PAP%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/PAP%202.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/PAP%203.png",
];

const SkybarSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19Ta3liYXIoSU5UKUU=",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Skybar%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Skybar%202.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Skybar%203.png",
];

const AllInclusiveSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUyMDgoSU5UKUU%3D",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/Luxury%20Suites%202.jpg",
];

const FujitecSuperSuiteImages = [
  "https://venues.3ddigitalvenue.com/great-american-reds?view_id=U19TVEUyMzZTVEUyMzcoSU5UKUU=",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/LF%20SS%201.png",
  "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/Suite%20Images/LF%20SS%202.png",
];

const config: TeamConfig = {
  teamSchema: "cincinnatireds_suites",
  browserTitle: "Cincinnati Reds Suites",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 140,
  teamName: "Cincinnati Reds",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10186-reds-sec",
    mapId: "blockmap2d",
    isShowAvailableSeatsButtonHidden: true,
    hide3dViewFromSlider: [
      "TriplePlaySuites",
      "STE202",
      "HardRockSuperSuite",
      "LeftFieldSuperSuite",
      "NorCom TechnologySuperSuite",
      "ExecutiveSuperSuite",
      "TriHealthCenterFieldPavillion",
      "MachineRoomPatio",
      "TireDiscountersPartyDecks",
      "PowerAlleyPatio",
      "Skybar",
    ],

    suiteImages: {
      TriplePlaySuites: TriplePlayPartySuiteImages,
      STE202: HomePlateSuperSuiteImages,
      HardRockSuperSuite: ThirdBaseSuperSuiteImages,
      LeftFieldSuperSuite: OutFieldSuperSuiteImages,
      "NorCom TechnologySuperSuite": FujitecSuperSuiteImages,
      ExecutiveSuperSuite: ExecutiveSuperSuiteImages,
      TriHealthCenterFieldPavillion: CenterFieldPavilionSuiteImages,
      MachineRoomPatio: MachineRoomPatioSuiteImages,
      TireDiscountersPartyDecks: PartyDeckSuiteImages,
      PowerAlleyPatio: PowerAlleyPatioSuiteImages,
      Skybar: SkybarSuiteImages,
      101: AllInclusiveSuiteImages,
      102: AllInclusiveSuiteImages,
      103: AllInclusiveSuiteImages,
      104: AllInclusiveSuiteImages,
      105: AllInclusiveSuiteImages,
      106: AllInclusiveSuiteImages,
      107: AllInclusiveSuiteImages,
      108: AllInclusiveSuiteImages,
      LS109: AllInclusiveSuiteImages,
      LS110: AllInclusiveSuiteImages,
      LS111: AllInclusiveSuiteImages,
      LS112: AllInclusiveSuiteImages,
      LS113: AllInclusiveSuiteImages,
      LS114: AllInclusiveSuiteImages,
      LS115: AllInclusiveSuiteImages,
      LS116: AllInclusiveSuiteImages,
      LS203: AllInclusiveSuiteImages,
      LS204: AllInclusiveSuiteImages,
      LS205: AllInclusiveSuiteImages,
      LS206: AllInclusiveSuiteImages,
      LS207: AllInclusiveSuiteImages,
      LS208: AllInclusiveSuiteImages,
      LS209: AllInclusiveSuiteImages,
      LS211: AllInclusiveSuiteImages,
      LS212: AllInclusiveSuiteImages,
      LS213: AllInclusiveSuiteImages,
      LS214: AllInclusiveSuiteImages,
      LS215: AllInclusiveSuiteImages,
      LS216: AllInclusiveSuiteImages,
      LS218: AllInclusiveSuiteImages,
      LS219: AllInclusiveSuiteImages,
      LS220: AllInclusiveSuiteImages,
      LS221: AllInclusiveSuiteImages,
      LS222: AllInclusiveSuiteImages,
      LS223: AllInclusiveSuiteImages,
      LS224: AllInclusiveSuiteImages,
      LS225: AllInclusiveSuiteImages,
      LS226: AllInclusiveSuiteImages,
      LS227: AllInclusiveSuiteImages,
      LS228: AllInclusiveSuiteImages,
      LS229: AllInclusiveSuiteImages,
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    hideViewTicketsInThankYouPage: true,

    isCheckoutAdditionalDetailsEnabled: true,

    invPreviewAccountGroup: ["0"],
    allowCheckoutFromPreview: true,
    isPerksEnabled: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    googleTagManagerId: "",
    AnalyticsHeader,
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: false,

  // urls
  accountManagerUrl: "https://www.mlb.com/reds/tickets",

  // vendor
  platform: vendorUUIDs.tickesdotcom,

  // okta config
  oktaIssuer: "https://ids.mlb.com/oauth2/aus1m088yK07noBfh356",
  oktaClientId: "0oasmcdgh92Jom7TI357",
  shouldUseInternalLogin: false,

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage,
    findGamesBannerImage: BannerImage,
    authBackgroundImage: BackgroundImage,
    seatMap3dPreviewImage: SeatMap3dPreview,
    checkoutStatusPageImage: BackgroundImage,
    giftCardStandalonePageImage: BannerImage,
    logoImage: LogoImage + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    gameFiltersSettings: {
      hideSectionFilter: true,
    },

    hidePackageBalanceOnCheckout: true,
    hideServiceFee: true,

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      seatCountLabel: "Tickets Included:",
      inventorySuitePackageInfo: [],
      pbLineItemsValue: 5,
      FBLabel: "Food & Beverage:",
      isParkingSeatCountVisible: true,

      suiteLevelInventoryCard: {
        customButtons: [
          {
            id: 1,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <TriplePlayPartySuiteContent />,
              });
            },
            suiteNames: triplePlayPartySuiteNames,
          },
          {
            id: 2,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <HomePlateSuperSuiteContent />,
              });
            },
            suiteNames: homePlateSuperSuiteNames,
          },
          {
            id: 3,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <ThirdBaseSuperSuiteContent />,
              });
            },
            suiteNames: thirdBaseSuperSuiteNames,
          },
          {
            id: 4,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <OutFieldSuperSuiteContent />,
              });
            },
            suiteNames: outFieldSuperSuiteNames,
          },
          {
            id: 5,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <ExecutiveSuiteContent />,
              });
            },
            suiteNames: executiveSuperSuiteNames,
          },
          {
            id: 6,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <CenterFieldPavilionSuiteContent />,
              });
            },
            suiteNames: centerFieldPavilionSuiteNames,
          },
          {
            id: 7,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <MachineRoomPatioSuiteContent />,
              });
            },
            suiteNames: machineRoomPatioSuiteNames,
          },
          {
            id: 8,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <PartyDeckSuiteContent />,
              });
            },
            suiteNames: partyDeckSuiteNames,
          },
          {
            id: 9,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <PowerAlleyPatioSuiteContent />,
              });
            },
            suiteNames: powerAlleyPatioSuiteNames,
          },
          {
            id: 10,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <SkybarSuiteContent />,
              });
            },
            suiteNames: skybarSuiteNames,
          },
          {
            id: 11,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <AllInclusiveSuiteContent />,
              });
            },
            suiteNames: allInclusiveSuiteNames,
          },
          {
            id: 12,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <FujitecSuperSuiteContent />,
              });
            },
            suiteNames: fujitecSuperSuiteNames,
          },
        ],
        renderBody: [
          {
            id: 1,
            component: () => <InventoryCard />,
          },
        ],
      },

      suiteLevelInventoryCardFooterText: {
        TriplePlaySuites:
          "Additional tickets available for purchase at checkout.",
        STE202: "Additional tickets available for purchase at checkout.",
        HardRockSuperSuite:
          "Additional tickets available for purchase at checkout.",
        LeftFieldSuperSuite:
          "Additional tickets available for purchase at checkout.",
        "NorCom TechnologySuperSuite":
          "Additional tickets available for purchase at checkout.",
        ExecutiveSuperSuite:
          "Additional tickets available for purchase at checkout.",
        TriHealthCenterFieldPavillion:
          "Additional tickets available for purchase at checkout.",
        MachineRoomPatio:
          "Additional tickets available for purchase at checkout.",
        TireDiscountersPartyDecks:
          "Additional tickets available for purchase at checkout.",
        PowerAlleyPatio:
          "Additional tickets available for purchase at checkout.",
        Skybar: "Additional tickets available for purchase at checkout.",
      },
    },
    inventoryContainer: {
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 180),
    },

    checkoutPage: {
      checkoutForm: {
        hideContractFirstName: true,
        hideContractLastName: true,
      },
    },

    shouldDisplayServiceFee: false,
    shouldAddServiceFeeWithPerkPrice: true,
  },

  colors: {
    primary: "#C6011F",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <CheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    additionalDetailsDisclaimerTC: <AdditionalDetailsDisclaimerTC />,
    purchaseSeats: {
      progressBarSuccessText:
        "You're good to go! Add more games or select Continue to view seating options.",
      progressBarAditionalText: " to continue!",
      noSessionsAvailable:
        "Check back soon for 2026 online suite availability.",
      noSessionsAvailableDescription: " ",
      sameAsContractSignerLabel: "Same as Contact Above",
      suiteLanguageDisclaimer:
        "Please note that individual suites may vary from the photos displayed.",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your mlb.com account to continue with seamless access.",
  },
};

export default config;
